import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Card,Checkbox } from '@mui/material';
import { colors } from '../../theme';
import {
    Container,
    Row,
    Col,
} from 'react-bootstrap';
import {
    AddAgentTitle,
    AddAgentInputTitle,
    InputText,
    OrganizationItem,
    TextArea
} from './styles';
import './index.css';

const CreateAgentDialog = ({
    active,
    handleClose,
    title,
    createConstructorName,
    setCreateConstructorName,


    isForUpdateConstructor,
    selectedNextConstructor,
    setSelectedNextConstructor,
    selectedCampaignForCreate,
    setSelectedCampaignForCreate,
    selectedExecutors,
    setSelectedExecutors,
    showSelecteConstructor,
    setShowSelecteConstructor,
    constructorListForCreate,
    selectedContructorForCreate,
    setSelectedContructorForCreate,
    handleFilterConstructor,
    campaignListLocal,
    showSelectCampaign,
    setShowSelectCampaign,
    handleFilterCampaign,
    showSelecteExecutor,
    setShowSelecteExecutor,
    setLocalExecutorList,
    localExecutorList,
    handleFilterExecutor,
    checkToggleInExecutor,
    selectionDone,
    handleAction


}) => {

    return (
        <>
            <Dialog

                open={active}
            >
                <DialogTitle style={{
                    backgroundColor: colors.inputBackgroundColor,
                    color: colors.white
                }}>
                    <AddAgentTitle>{title}</AddAgentTitle></DialogTitle>
                <DialogContent style={{ backgroundColor: colors.inputBackgroundColor }}>
                    <Container fluid>
                        <Row style={{ width: "30vw", marginTop: 16 }} >
                            <Col>
                                <AddAgentInputTitle>Name</AddAgentInputTitle>
                            </Col>
                            <Col>
                                <InputText
                                    placeholder='Enter name'
                                    className='agentSearchClass'
                                    value={createConstructorName}
                                    onChange={(e) => {
                                        setCreateConstructorName(e.target.value);
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row style={{ width: "30vw", marginTop: 16 }} >
                            <Col>
                                <AddAgentInputTitle>Next Constructor</AddAgentInputTitle>
                            </Col>
                            <Col>
                                <InputText
                                    placeholder='(Optional)'
                                    className='agentSearchClass'
                                    value={selectedContructorForCreate?.name ? selectedContructorForCreate?.name : ""}
                                    onClick={(e) => {
                                        setShowSelecteConstructor(!showSelecteConstructor);

                                    }}
                                />
                            </Col>
                        </Row>

                        <Row style={{ width: "30vw", marginTop: 16 }} >
                            <Col>
                                <AddAgentInputTitle>Campaign</AddAgentInputTitle>
                            </Col>
                            <Col>
                                <InputText
                                    placeholder='Select Campaign'
                                    className='agentSearchClass'
                                    value={selectedCampaignForCreate?.name != undefined ? selectedCampaignForCreate?.name : ""}
                                    onClick={(e) => {
                                        // setShowPromptDialog(!showPromptDialog)
                                        setShowSelectCampaign(!showSelectCampaign);
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row style={{ width: "30vw", marginTop: 16 }} >
                            <Col>
                                <AddAgentInputTitle>Exectors</AddAgentInputTitle>
                            </Col>
                            <Col>

                                {selectedExecutors.length ?
                                    <>
                                        {selectedExecutors?.map((data, i) => {
                                            return (
                                                <InputText
                                                    placeholder='campain ID'
                                                    className='agentSearchClass'
                                                    value={data}
                                                   // disabled
                                                    style={{ marginTop: 10 }}
                                                    onClick={() => {
                                                        setShowSelecteExecutor(!showSelecteExecutor)
                                                    }}
                                                />
                                            )
                                        })}
                                    </>
                                    : <InputText
                                        placeholder='Selecte Executor'
                                        className='agentSearchClass'
                                        // value={"None"}
                                        onClick={() => {
                                            setShowSelecteExecutor(!showSelecteExecutor)
                                        }}
                                    />}
                            </Col>
                        </Row>


                    </Container>
                </DialogContent>
                <DialogActions style={{ backgroundColor: colors.inputBackgroundColor, paddingBottom: 16 }}>
                    <Button onClick={() => {
                         handleAction()
                    }}
                        style={{
                            color: colors.white,
                            fontWeight: "bolder"
                        }}

                    > {isForUpdateConstructor ? "Update" : "Create"}</Button>
                    <Button onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={showSelecteConstructor}
            >
                <DialogTitle style={{
                    backgroundColor: colors.inputBackgroundColor,
                    color: colors.white
                }}>
                    <AddAgentTitle>Connect Constructor</AddAgentTitle></DialogTitle>
                <DialogContent style={{ backgroundColor: colors.inputBackgroundColor }}>
                    <Container fluid>
                        <Row style={{ width: "30vw", marginTop: 16 }} >

                            <Col>
                                <center>
                                    <InputText
                                        placeholder='Search construtor'
                                        className='agentSearchClass'
                                        style={{ textAlign: "center", width: 200 }}
                                        onChange={(e) => {
                                            handleFilterConstructor(e.target.value);
                                        }}


                                    />
                                </center>

                            </Col>
                        </Row>

                        <ul style={{ width: "30vw", marginTop: 16, height: "40vh", listStyleType: "none", padding: 0 }} >

                            {constructorListForCreate.length == 0 &&

                                <OrganizationItem>Constructor not found</OrganizationItem>
                            }
                            {constructorListForCreate.map((data, i) => {
                                return (
                                    <Card
                                        onClick={() => {
                                            setSelectedContructorForCreate(data)
                                            setShowSelecteConstructor(!showSelecteConstructor);

                                        }}
                                        style={{
                                            backgroundColor: colors.splitLineColor,
                                            marginTop: 20,
                                            padding: 10
                                        }}
                                    >
                                        <OrganizationItem>{data.name}</OrganizationItem>
                                        <OrganizationItem style={{ color: colors.activeBlue, fontWeight: "600", fontSize: 13 }}>ID : {data.id}</OrganizationItem>
                                    </Card>
                                );
                            })}


                        </ul>

                    </Container>

                </DialogContent>
                <DialogActions style={{ backgroundColor: colors.inputBackgroundColor }}>
                    <Button onClick={() => {
                        setSelectedContructorForCreate({});
                        setShowSelecteConstructor(!showSelecteConstructor);

                    }}
                        style={{
                            color: colors.white,
                            fontWeight: "bolder"
                        }}>Clear</Button>
                    <Button onClick={() => {
                        setShowSelecteConstructor(!showSelecteConstructor)
                    }}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog

                open={showSelectCampaign}

            >
                <DialogTitle style={{
                    backgroundColor: colors.inputBackgroundColor,
                    color: colors.white
                }}>
                    <AddAgentTitle>Choose Campaign</AddAgentTitle></DialogTitle>
                <DialogContent style={{ backgroundColor: colors.inputBackgroundColor }}>
                    <Container fluid>
                        <Row style={{ width: "30vw", marginTop: 16 }} >

                            <Col>
                                <center>
                                    <InputText
                                        placeholder='Search campain'
                                        className='agentSearchClass'
                                        style={{ textAlign: "center", width: 200 }}
                                        onChange={(e) => {
                                            handleFilterCampaign(e.target.value);
                                        }}


                                    />
                                </center>

                            </Col>
                        </Row>

                        <ul style={{ width: "30vw", marginTop: 16, height: "40vh", listStyleType: "none", padding: 0 }} >

                            {campaignListLocal.length == 0 &&

                                <OrganizationItem>Campaign not found</OrganizationItem>
                            }
                            {campaignListLocal.map((data, i) => {
                                return (
                                    <Card
                                        onClick={() => {
                                            setSelectedCampaignForCreate(data)
                                            setShowSelectCampaign(!showSelectCampaign);

                                        }}
                                        style={{
                                            backgroundColor: colors.splitLineColor,
                                            marginTop: 20,
                                            padding: 10
                                        }}
                                    >
                                        <OrganizationItem>{data.name}</OrganizationItem>
                                        <OrganizationItem style={{ color: colors.activeBlue, fontWeight: "600", fontSize: 13 }}>ID : {data.id}</OrganizationItem>
                                    </Card>
                                );
                            })}


                        </ul>

                    </Container>

                </DialogContent>
                <DialogActions style={{ backgroundColor: colors.inputBackgroundColor }}>
                    <Button onClick={() => {
                        setShowSelectCampaign(!showSelectCampaign)
                    }}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog

                open={showSelecteExecutor}

            >
                <DialogTitle style={{
                    backgroundColor: colors.inputBackgroundColor,
                    color: colors.white
                }}>
                    <AddAgentTitle>Choose Exectors</AddAgentTitle></DialogTitle>
                <DialogContent style={{ backgroundColor: colors.inputBackgroundColor }}>
                    <Container fluid>
                        <Row style={{ width: "30vw", marginTop: 16 }} >

                            <Col>
                                <center>
                                    <InputText
                                        placeholder='Search Executor'
                                        className='agentSearchClass'
                                        style={{ textAlign: "center", width: 200 }}
                                        onChange={(e) => {
                                            handleFilterExecutor(e.target.value);
                                        }}


                                    />
                                </center>

                            </Col>
                        </Row>

                        <ul style={{ width: "30vw", marginTop: 16, height: "40vh", listStyleType: "none", padding: 0 }} >

                            {localExecutorList.length == 0 &&

                                <OrganizationItem>Executor not found</OrganizationItem>
                            }
                            {localExecutorList.map((data, i) => {
                                return (
                                    <Card
                                        // onClick={() => {
                                        //     // setSelectedModel(data)
                                        //     // setShowModelSelectDialog(!showModelSelectDialog);
                                        // }}
                                        style={{
                                            backgroundColor: colors.splitLineColor,
                                            marginTop: 20,
                                            padding: 10
                                        }}
                                    >
                                        <Row>
                                            <Col style={{textAlign:"center"}}>
                                                <OrganizationItem>{data.name}</OrganizationItem>
                                                <OrganizationItem style={{ color: colors.activeBlue, fontWeight: "600", fontSize: 13 }}>ID : {data.id}</OrganizationItem>
                                            </Col>
                                            
                                            <Col style={{textAlign:"right"}}>
                                                <Checkbox
                                                    checked={data.toggle}
                                                    onClick={()=>{
                                                        checkToggleInExecutor(data);
                                                    }}
                                                    
                                                />
                                            </Col>
                                        </Row>
                                    </Card>
                                );
                            })}


                        </ul>

                    </Container>

                </DialogContent>
                <DialogActions style={{ backgroundColor: colors.inputBackgroundColor }}>
                <Button onClick={() => {
                         selectionDone();
                         setShowSelecteExecutor(!showSelecteExecutor);
                    }}
                        style={{
                            color: colors.white,
                            fontWeight: "bolder"
                        }}

                    > {"Done"}</Button>
                    <Button onClick={() => {

                        setShowSelecteExecutor(!showSelecteExecutor);
                    }}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default CreateAgentDialog;